import * as yup from 'yup'

import { 
    trimmedInputValues,
} from '../utils';

const DeliveryDetailsValidation = yup.object().shape({
    deliveredNote: yup.string()
        .required('Please enter delivered note')
        .transform((value) => trimmedInputValues(value)),
    deliveredTo: yup.string()
        .required('Please enter delivered to')
        .transform((value) => trimmedInputValues(value)),
    deliveredOn: yup.string()
        .required('Please select delivery date')
});

const initialDeliveryDetails = {
    deliveredOn:  new Date(new Date()),
    deliveredTo: "",
    deliveredNote: "",
}

export { DeliveryDetailsValidation, initialDeliveryDetails }